import { useEffect } from 'react';

const ServiceWorkerRegister = () => {
  useEffect(() => {
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      // Defer service worker registration to idle time to reduce main thread blocking
      const registerSW = () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('SW registered: ', registration);
            
            // Request persistent storage using modern API
            if ('storage' in navigator && 'persist' in navigator.storage) {
              navigator.storage.persist().then((persistent) => {
                if (persistent) {
                  console.log('Storage persisted successfully');
                }
              });
            }
            
            // Clean cache periodically
            setInterval(() => {
              if (registration.active) {
                registration.active.postMessage({ type: 'CLEAN_CACHE' });
              }
            }, 60 * 60 * 1000); // Every hour
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError);
          });
      };

      // Use requestIdleCallback to defer registration
      if ('requestIdleCallback' in window) {
        requestIdleCallback(registerSW, { timeout: 2000 });
      } else {
        // Fallback for browsers without requestIdleCallback
        setTimeout(registerSW, 1000);
      }
    }
  }, []);

  return null;
};

export default ServiceWorkerRegister;